<template>
  <date-picker v-bind="$attrs" v-on="$listeners" lang="en" ref="datePicker" />
</template>

<script>
import DatePicker from 'libs/datepicker';

export default {
  components: {
    'date-picker': DatePicker,
  },
  methods: {
    /**
     * open the date picker dialog
     * @param {Boolean} force open the dialog even if dates been pick
     */
    open(force = false) {
      const input = this.$refs.datePicker.$el.querySelector(
        '.mx-input-wrapper input'
      );
      if (force || !input.value) {
        input.click();
      }
    },
  },
  inheritAttrs: false,
};
</script>
